import {Grid} from "@mui/material"
import { MainCategoryContainerStyled, CategoryContainerStyled, CategoryHeaderStyled, CategoryHeaderArStyled,  CategorySubHeaderStyled, CategorySubHeaderArStyled, CategoryGridStyled, ItemContainerStyled, ItemImageContainer, ItemBoxTwoStyled, ItemDetailsContainer, ItemDetailsStyled, ItemDetailsArStyled,  ItemPriceContainer, ItemPriceContainerAr, ItemNameStyled, ItemNameArStyled } from "./generalStyles";
import styled from "styled-components";

function BeveragesGrid({triggerLanguage, beveragesItems, coffeeItems, teaItems}) {

    if(triggerLanguage == "en") {
        return (
            <MainCategoryContainerStyled>
                <CategoryContainerStyled>
                        <CategoryHeaderStyled>
                            Beverages
                        </CategoryHeaderStyled>
                        <CategoryGridStyled>
                            <Grid container spacing = {2} rowSpacing = {4}>
                            {
                                beveragesItems.map(({name_en, description_en, price, image}) => {
                                    return (
                                        <Grid item xs = {6} sm = {6}>
                                            <ItemContainerStyled>
                                                <ItemImageContainer>
                                                    <img src = {image} />
                                                </ItemImageContainer>
                                                <ItemBoxTwoStyled>
                                                    <ItemDetailsContainer>
                                                        <div>
                                                            <ItemNameStyled>
                                                                {name_en}
                                                            </ItemNameStyled>
                                                            <ItemDetailsStyled>{description_en}</ItemDetailsStyled>
                                                        </div>
                                                    </ItemDetailsContainer>
                                                    <ItemPriceContainer>
                                                        {price} <span>QR</span>
                                                    </ItemPriceContainer>
                                                </ItemBoxTwoStyled>
                                            </ItemContainerStyled>
                                        </Grid>
                                    )
                                })
                            }
                            </Grid>
                        </CategoryGridStyled>
                    </CategoryContainerStyled>
                    <CategoryContainerStyled>
                    <CategorySubHeaderStyled>
                            COFFEE
                        </CategorySubHeaderStyled>
                        <CategoryGridStyled>
                            <Grid container spacing = {2} rowSpacing = {4}>
                            {
                                coffeeItems.map(({name_en, description_en, price, image}) => {
                                    return (
                                        <Grid item xs = {6} sm = {6}>
                                            <ItemContainerStyled>
                                                <ItemImageContainer>
                                                    <img src = {image} />
                                                </ItemImageContainer>
                                                <ItemBoxTwoStyled>
                                                    <ItemDetailsContainer>
                                                        <div>
                                                            <ItemNameStyled>
                                                                {name_en}
                                                            </ItemNameStyled>
                                                            <ItemDetailsStyled>{description_en}</ItemDetailsStyled>
                                                        </div>
                                                    </ItemDetailsContainer>
                                                    <ItemPriceContainer>
                                                        {price} <span>QR</span>
                                                    </ItemPriceContainer>
                                                </ItemBoxTwoStyled>
                                            </ItemContainerStyled>
                                        </Grid>
                                    )
                                })
                            }
                            </Grid>
                        </CategoryGridStyled>
                    </CategoryContainerStyled>
                    <CategoryContainerStyled>
                        <CategorySubHeaderStyled>
                            TEA
                        </CategorySubHeaderStyled>
                        <CategoryGridStyled>
                            <Grid container spacing = {2} rowSpacing = {4}>
                            {
                                teaItems.map(({name_en, description_en, price, image}) => {
                                    return (
                                        <Grid item xs = {6} sm = {6}>
                                            <ItemContainerStyled>
                                                <ItemImageContainer>
                                                    <img src = {image} />
                                                </ItemImageContainer>
                                                <ItemBoxTwoStyled>
                                                    <ItemDetailsContainer>
                                                        <div>
                                                            <ItemNameStyled>
                                                                {name_en}
                                                            </ItemNameStyled>
                                                            <ItemDetailsStyled>{description_en}</ItemDetailsStyled>
                                                        </div>
                                                    </ItemDetailsContainer>
                                                    <ItemPriceContainer>
                                                        {price} <span>QR</span>
                                                    </ItemPriceContainer>
                                                </ItemBoxTwoStyled>
                                            </ItemContainerStyled>
                                        </Grid>
                                    )
                                })
                            }
                            </Grid>
                        </CategoryGridStyled>
                    </CategoryContainerStyled>
            </MainCategoryContainerStyled>
        )
    }

    if(triggerLanguage == "ar") {
        return (
            <MainCategoryContainerStyled>
               <CategoryContainerStyled>
                    <CategoryHeaderArStyled>
                    مشروبات
                    </CategoryHeaderArStyled>
                    <CategoryGridStyled>
                        <Grid container spacing = {2} rowSpacing = {4}>
                        {
                            beveragesItems.map(({name_ar, description_ar, price, image}) => {
                                return (
                                    <Grid item xs = {6} sm = {6}>
                                        <ItemContainerStyled>
                                            <ItemImageContainer>
                                                <img src = {image} />
                                            </ItemImageContainer>
                                            <ItemBoxTwoStyled>
                                                <ItemPriceContainerAr>
                                                    <div>{price}</div>
                                                    <div><span>ر.ق</span></div>   
                                                </ItemPriceContainerAr>
                                                <ItemDetailsContainer style = {{textAlign: "right"}}>
                                                    <div>
                                                        <ItemNameArStyled>
                                                            {name_ar}
                                                        </ItemNameArStyled>
                                                        <ItemDetailsArStyled>{description_ar}</ItemDetailsArStyled>
                                                    </div>
                                                </ItemDetailsContainer>
                                            </ItemBoxTwoStyled>
                                        </ItemContainerStyled>
                                    </Grid>
                                )
                            })
                        }
                        </Grid>
                    </CategoryGridStyled>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                <CategorySubHeaderArStyled>
                قهوة (بارد - ساخن)
                    </CategorySubHeaderArStyled>
                    <CategoryGridStyled>
                        <Grid container spacing = {2} rowSpacing = {4}>
                        {
                            coffeeItems.map(({name_ar, description_ar, price, image}) => {
                                return (
                                    <Grid item xs = {6} sm = {6}>
                                        <ItemContainerStyled>
                                            <ItemImageContainer>
                                                <img src = {image} />
                                            </ItemImageContainer>
                                            <ItemBoxTwoStyled>
                                                <ItemPriceContainerAr>
                                                    <div>{price}</div>
                                                    <div><span>ر.ق</span></div>   
                                                </ItemPriceContainerAr>
                                                <ItemDetailsContainer style = {{textAlign: "right"}}>
                                                    <div>
                                                        <ItemNameArStyled>
                                                            {name_ar}
                                                        </ItemNameArStyled>
                                                        <ItemDetailsArStyled>{description_ar}</ItemDetailsArStyled>
                                                    </div>
                                                </ItemDetailsContainer>
                                            </ItemBoxTwoStyled>
                                        </ItemContainerStyled>
                                    </Grid>
                                )
                            })
                        }
                        </Grid>
                    </CategoryGridStyled>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <CategoryHeaderArStyled>
                    شاي
                    </CategoryHeaderArStyled>
                    <CategoryGridStyled>
                        <Grid container spacing = {2} rowSpacing = {4}>
                        {
                            teaItems.map(({name_ar, description_ar, price, image}) => {
                                return (
                                    <Grid item xs = {6} sm = {6}>
                                        <ItemContainerStyled>
                                            <ItemImageContainer>
                                                <img src = {image} />
                                            </ItemImageContainer>
                                            <ItemBoxTwoStyled>
                                                <ItemPriceContainerAr>
                                                    <div>{price}</div>
                                                    <div><span>ر.ق</span></div>   
                                                </ItemPriceContainerAr>
                                                <ItemDetailsContainer style = {{textAlign: "right"}}>
                                                    <div>
                                                        <ItemNameArStyled>
                                                            {name_ar}
                                                        </ItemNameArStyled>
                                                        <ItemDetailsArStyled>{description_ar}</ItemDetailsArStyled>
                                                    </div>
                                                </ItemDetailsContainer>
                                            </ItemBoxTwoStyled>
                                        </ItemContainerStyled>
                                    </Grid>
                                )
                            })
                        }
                        </Grid>
                    </CategoryGridStyled>
                </CategoryContainerStyled>
            </MainCategoryContainerStyled>
        )
    }
}

const TeaStyled = styled.div`
    display:flex;
    flex-direction: column;
    gap: 10px;

    span {
        font-size: 18px;
        font-weight: bold;
    }
`

const TeaArStyled = styled.div`
    display:flex;
    flex-direction: column;
    gap: 10px;
    text-align: right;

    span {
        font-size: 18px;
        font-weight: bold;
    }
`

export default BeveragesGrid;